<div class="row">
  <div class="col-lg-12 stretch-card">
    <div class="card">
      <div class="d-flex flex-wrap justify-content-between align-items-center card-header">
        <h2 class="h5 card-title mb-2 mb-md-0">Daily received volume (litre)</h2>
        <div class="chart-filter form-group mb-0">
          <label class="mb-1 sr-only" for="flow_chart_range">Chart range</label>
          <select id="flow_chart_range" class="form-control form-control-sm"
            name="chart_range" [(ngModel)]="chart_range" (change)="onChartRangeChange()"
            aria-label="Chart range">
            <option value="7">Last 7 days</option>
            <option value="30">Last 30 days</option>
            <option value="month">This month</option>
          </select>
        </div>
      </div>
      <div class="card-body">
        <div id="flowTrackingVolumeChart"
          style="width: 100%; height: 320px;"
          role="img"
          [attr.aria-label]="'Daily received volume chart. ' + chart_summary">
        </div>
        <p class="sr-only">{{ chart_summary }}</p>
      </div>
    </div>
  </div>
</div>